import { sendSumoLog } from './sumoLogger';
import { updateCurStandbyInspector, updateError } from '../../stores/notifications';
import { GET_STANDBY_INSPECTOR_BY_ID } from '../queries/queries';
import GetApolloClient from '../../Apollo';

/**
 * Retrieve the details of a Standby Inspector.
 *
 * @param token - authentication token from active auth.
 * @param dispatch - redux dispatch to dispatch state changes.
 * @param id - the id of the Standby Inspector details to retrieve.
 * @param immediate - whether to immediately return the results (rather than using dispatch)
 * @returns {Promise<StandbyInspector>} - The details for the specified Standby Inspector.
 */
export const fetchStandbyInspector = async (
  token,
  dispatch,
  id,
  immediate = false
) => {
  const client = GetApolloClient(token);

  try {
    const {
      data: { getStandbyInspectorById: curStandbyInspector },
    } = await client.query({
      query: GET_STANDBY_INSPECTOR_BY_ID,
      variables: { id: `${id}` },
    });

    if (immediate) {
      return curStandbyInspector;
    }

    updateCurStandbyInspector(curStandbyInspector, dispatch);
  } catch (error) {
    const isInternalError = error instanceof Error;
    const errorType = 'fetchStandbyInspector';
    const errorCode = isInternalError ? 500 : error.errorCode;
    sendSumoLog(errorType, error.message, errorCode, dispatch);
    updateError(error, dispatch);
    return null;
  }
};
